export interface AdminCreateFullAttendanceDto {
	endDate: Date;
	siteId: number;
	staffMemberId: number;
	startDate: Date;
}

export class AdminCreateFullAttendanceDto implements AdminCreateFullAttendanceDto {
	constructor(data?: Partial<AdminCreateFullAttendanceDto>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}